module.exports = __webpack_public_path__ + "static/media/clemazon.aa17d59f.jpg";